export default __webpack_public_path__ + "static/media/avatar_27.10989bb0.png";